import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GiftCertificatesService {
    private baseURL: string;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    // Get gift certificates list
    getGiftCertificates(asOfDate: string, status: string): Observable<any> {
        return this.http
            .get<any>(
                `${this.baseURL}/GiftCertificates/GetGiftCertificates?status=${status}&asOfDate=${asOfDate}`,
                { observe: 'response' }
            )
            .pipe(
                map((res: HttpResponse<any>) => res.body),
                catchError(this.handleError)
            );
    }

    // Get details for a single certificate
    getGiftCertificateDetails(giftCertNo: string): Observable<any> {
        return this.http
            .get<any>(
                `${this.baseURL}/GiftCertificates/GetGiftCertificateDetails/${giftCertNo}`,
                { observe: 'response' }
            )
            .pipe(
                map((res: HttpResponse<any>) => res.body),
                catchError(this.handleError)
            );
    }

    getDefaultMarketId(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/User/GetDefaultMarketId`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    // Renew / Update Expiry Date of Gift Certificate
    renewGiftCertificate(payload: any): Observable<any> {
        return this.http
            .post<any>(
                `${this.baseURL}/GiftCertificates/RenewGiftCertificate`,
                payload,
                { observe: 'response' }
            )
            .pipe(
                map((res: HttpResponse<any>) => res.body),
                catchError(this.handleError)
            );
    }


    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
